module.exports = __webpack_public_path__ + "img/banner1@2x.720ecb8d.png";